<template>
    <div class="item slideRight" :class="[{ 'has-draft-tag': showDraftRecordsTag }, $mq]">
        <div class="list" @click="sendedId()">
            <div class="category" v-if="catSelected && catSelected.id == 'all' && categories[item.category_id]">
                <div class="ball" :style="{ backgroundColor: categories[item.category_id] ? categories[item.category_id].color : '' }"></div>
                <div class="category-name">
                    {{ categories[item.category_id] ? categories[item.category_id].name : '' }}
                </div>
            </div>
            <h6 class="name">{{ item.name }}</h6>
            <InfoQuantityTag
                v-if="showDraftRecordsTag"
                class="draft-records-tag"
                icon="i-andy-circle-exclamation"
                label="register.draft_tag"
                :value="draftCount"
                textColor="#B99000"
                backgroundColor="#FFFACD"
            />
            <!-- <span class="subname">{{ $t('register.last_time') }}: {{ item.last_update | moment }}</span> -->
        </div>
        <div class="create" v-if="userAppAccess && checkPermission" @click="sendedAddedit()">
            <div class="add"></div>
        </div>
    </div>
</template>

<script>
import InfoQuantityTag from '@/components/domain/ui/InfoQuantityTag.vue'

export default {
    components: {
        InfoQuantityTag
    },
    props: {
        item: { type: Object },
        catSelected: { type: undefined, default: null },
        checkPermission: { type: Boolean, default: true }
    },
    data() {
        return {}
    },
    computed: {
        userAppAccess() {
            return this.$store.getters['loginUser/getHasAccessApp']
        },
        user_id() {
            return this.$store.getters['loginUser/getLocalEmployee']
        },
        categories() {
            var items = this.$store.getters['register/getCategories']()
            return items
        },
        user() {
            var employee = this.$store.getters['employee/getEmployee'](this.user_id)
            if (employee) {
                return employee
            }
        },
        roleUserLogged() {
            var user = this.$store.getters['loginUser/getLocalEmployee']
            var roleUserLogged = this.$store.getters['employee/getEmployee'](user)
            var levelRoleUserLogged = this.$store.getters['employee/getRol'](roleUserLogged.rol)
            return levelRoleUserLogged
        },
        showRadarTool() {
            return this.$store.getters['getShowRadarTool']
        },
        showDraftRecordsTag() {
            return this.showRadarTool && this.draftCount > 0
        },
        draftCount() {
            return parseInt(this.item && this.item.open_count, 10) || 0
        }
    },
    methods: {
        sendedId() {
            this.$emit('sendedId', this.item.id)
        },
        sendedAddedit(id) {
            this.$emit('addEdit', this.item.id)
        }
    },
    filters: {
        moment: function (date) {
            return date ? moment(date).fromNow() : '--'
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

$add-size: rem(35px);
$item-height: rem(80px);

.item {
    @include interaction();
    @include border-radius(6px);
    @include display-flex();
    @include align-items();
    @include flex-wrap(wrap);
    background-color: #fff;
    width: calc(50% - 12px);
    height: 110px;
    overflow: hidden;

    @include bgHover(#fff);

    box-sizing: border-box;

    .list {
        width: calc(100% - #{rem(70px)});
        box-sizing: border-box;
        padding: 1em;
        max-height: 100%;

        h6{
            padding: 0px;
        }

        .category {
            @include display-flex();
            @include align-items();
            padding-bottom: 4px;

            .ball {
                @include display-inline-flex();
                @include border-radius(100%);
                width: 14px;
                height: 14px;
                margin-right: 6px;
            }
            .category-name {
                @include font-size(s);
                color: $neutro-s60;
                font-family: $text-light;
            }
        }

        .name {
            @include font-size(m);
            margin: 0;
            font-family: $text-bold;
            color: $inactive-s90;
            width: calc(100% - #{$add-size});
            max-height: calc(100% - 24px);

            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .draft-records-tag {
            margin-top: 8px;
            max-width: 100%;
        }

        ::v-deep .draft-records-tag {
            gap: 6px;

            .info-quantity-tag__text {
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .subname {
            @include font-size(s);
            height: 24px;
            width: calc(100% - #{$add-size});
            padding: 3px 6px;
            display: inline-block;
            color: $inactive-s50;
            font-family: $text-light;
        }
    }

    .create {
        width: rem(70px);
        height: 100%;
        padding: 20px 20px;
        display: grid;
        place-items: center;

        .add {
            @include border-radius(5px);
            @include background($color: $done, $image: img('more_ffffff.svg'), $size: 25px);
            width: $add-size;
            height: $add-size;

            @include bgHover($done);
        }
    }
    &.desktop {
        .create {
            padding: 24px 20px;
        }
    }
    &.has-draft-tag {
        height: auto;
        min-height: 110px;

        .list {
            .name {
                -webkit-line-clamp: 2;
            }
        }
    }
}

@media (max-width: 1000px) {
    .item {
        width: calc(100%);
    }
}

</style>

<!-- PORTRAIT STYLES -->
<style lang="scss" scoped>
$add-size: rem(40px);

.item.portrait {
    margin: 0;
    margin-bottom: 10px;
    min-height: 80px;
    height: fit-content !important;

    .list {
        width: calc(100% - #{rem(50px)});
        // max-height: 100%;
        max-height: none;
        padding: 0.7em !important;

        .name {
            max-height: none;
            @include font-size(sm);
        }
        .draft-records-tag {
            margin-top: 6px;
        }
        .subname {
            @include font-size(xs);
        }
    }
    .create {
        width: rem(50px);
        position: relative;

        .add {
            position: absolute;
            left: 0;
            right: 0;
            top: 50%;
            margin-top: -1.25rem;
        }
    }
}
</style>
